import { createContext, useContext, useState, ReactNode } from "react";

type Lang = "fr" | "en";
const LanguageContext = createContext<{ lang: Lang; setLang: (l: Lang) => void }>({ lang: "fr", setLang: () => {} });
export const useLang = () => useContext(LanguageContext);
export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLang] = useState<Lang>("fr");
  return <LanguageContext.Provider value={{ lang, setLang }}>{children}</LanguageContext.Provider>;
}
